import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || 'https://i-kept-all-the-code-in-github-and-now-i.onrender.com'}/api/admin-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (data.success) {
        // Store admin session in localStorage
        localStorage.setItem('siyaanish_admin', JSON.stringify({ email, role: 'admin', loggedInAt: Date.now() }));
        navigate('/admin/dashboard');
      } else {
        setError('Invalid credentials. Please try again.');
      }
    } catch (err) {
      setError('Server error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0f0d0a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Cormorant Garamond', Georgia, serif",
    }}>
      <div style={{
        width: '100%',
        maxWidth: 420,
        padding: '0 24px',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{
            fontSize: 11,
            letterSpacing: '0.5em',
            color: '#ba8245',
            textTransform: 'uppercase',
            marginBottom: 12,
            fontFamily: "'Cormorant Garamond', Georgia, serif",
          }}>
            Siyaanish
          </div>
          <div style={{
            fontSize: 28,
            color: '#f5f0e8',
            fontWeight: 300,
            letterSpacing: '0.08em',
          }}>
            Admin Portal
          </div>
          <div style={{
            width: 40,
            height: 1,
            background: 'rgba(186,130,69,0.4)',
            margin: '16px auto 0',
          }} />
        </div>

        {/* Form */}
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 24 }}>
            <label style={{
              display: 'block',
              fontSize: 10,
              letterSpacing: '0.35em',
              color: 'rgba(245,240,232,0.4)',
              textTransform: 'uppercase',
              marginBottom: 10,
            }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(186,130,69,0.2)',
                borderRadius: 6,
                padding: '14px 16px',
                color: '#f5f0e8',
                fontSize: 15,
                outline: 'none',
                boxSizing: 'border-box',
                fontFamily: "'Cormorant Garamond', Georgia, serif",
                transition: 'border-color 0.2s',
              }}
              onFocus={e => e.target.style.borderColor = 'rgba(186,130,69,0.6)'}
              onBlur={e => e.target.style.borderColor = 'rgba(186,130,69,0.2)'}
            />
          </div>

          <div style={{ marginBottom: 32 }}>
            <label style={{
              display: 'block',
              fontSize: 10,
              letterSpacing: '0.35em',
              color: 'rgba(245,240,232,0.4)',
              textTransform: 'uppercase',
              marginBottom: 10,
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(186,130,69,0.2)',
                borderRadius: 6,
                padding: '14px 16px',
                color: '#f5f0e8',
                fontSize: 15,
                outline: 'none',
                boxSizing: 'border-box',
                fontFamily: "'Cormorant Garamond', Georgia, serif",
                transition: 'border-color 0.2s',
              }}
              onFocus={e => e.target.style.borderColor = 'rgba(186,130,69,0.6)'}
              onBlur={e => e.target.style.borderColor = 'rgba(186,130,69,0.2)'}
            />
          </div>

          {error && (
            <div style={{
              background: 'rgba(220,38,38,0.1)',
              border: '1px solid rgba(220,38,38,0.3)',
              borderRadius: 6,
              padding: '12px 16px',
              color: '#fca5a5',
              fontSize: 13,
              marginBottom: 20,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              background: loading ? 'rgba(186,130,69,0.5)' : '#ba8245',
              color: '#0f0d0a',
              border: 'none',
              borderRadius: 6,
              padding: '15px',
              fontSize: 11,
              letterSpacing: '0.4em',
              textTransform: 'uppercase',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontWeight: 600,
              transition: 'background 0.2s',
            }}
          >
            {loading ? 'Signing in...' : 'Enter Panel'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
